<script lang="ts">
    import { MenuContextCustomActions } from '../MenuDropdown/MenuContextCustomActions';
    import IconCheck from '../../shared/Icons/IconCheck.svelte';
    import IconSettings from '../../shared/Icons/IconSettings.svelte';
    import MenuContextIcon from '../MenuDropdown/MenuContext/MenuContextIcon.svelte';
    import { EasyVrpApp } from './EasyVrpApp';

    export let onChange = () => {};
    export let app: EasyVrpApp; // Replace with actual type if available

    let menu = new MenuContextCustomActions();

    function updateMenu(menu: MenuContextCustomActions) {
        menu.reset();
        menu.addAction({
            id: 'delivery_order',
            label: 'pokazuj kolejność doręczeń/odbiorów',
            disabled: false,
            visible: true,
            icon: app.getSettingsDisplayOrderOnMap() ? IconCheck : null,
            onClick: () => {
                app.toggleSettingsDisplayOrderOnMap();
                updateMenu(menu);
                onChange();
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'easy_nuclei',
            label: 'pokazuj centrum kurierów',
            disabled: false,
            visible: true,
            icon: app.getSettingsDisplayNucleiOnMap() ? IconCheck : null,
            onClick: () => {
                app.toggleSettingsDisplayNucleiOnMap();
                updateMenu(menu);
                onChange();
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu = menu;
    }

    updateMenu(menu);
</script>

<MenuContextIcon {menu} iconSymbol={IconSettings} />
